var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,165.1l-6,21.82H85.92l-6-21.82m0-91.53,6-21.83H122l6,21.83m1.24,91.53H78.66a13.88,13.88,0,0,1-13.78-13.9V82.9a9.32,9.32,0,0,1,9.25-9.33h59.66A9.32,9.32,0,0,1,143,82.9v68.3A13.89,13.89,0,0,1,129.25,165.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.81,62.24l.12,0a17.3,17.3,0,0,1,19.41,14.94l0,.11m-19-26.85.13,0m0,0a27.2,27.2,0,0,1,30.54,23.5V74M136.4,39a36.55,36.55,0,0,1,41,31.56v.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartWatch);
export default __webpack_public_path__ + "static/media/SMART_WATCH.2afa0f8fa7871c9e9c645afcd085fcd1.svg";
export { ForwardRef as ReactComponent };